module.exports = __webpack_public_path__ + "media/images/leadership_characteristics/bg-3-0646941bab535cd9e7f6172be998cd49.png";